// extracted by mini-css-extract-plugin
module.exports = {"requiredMarker":"label_requiredMarker__3y4R0"};